import moment from "moment";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import { Conference, Props } from "./CoferencePopup.model";


export const useConferencePopup = ({ conference, onClose, onSubmit }: Props) => {

	const { post, put } = useFetchWrapper();

	const  defaultValues : any= {
			date: conference ? moment(conference?.date, 'YYYY-MM-DD') : null,
			name: conference ? conference?.name : undefined
		}
	const { control, formState: { errors }, handleSubmit, } = useForm({ defaultValues });
	
	const addConference = async (data: Conference) => {
		const response: HttpResponse<any> = await post('/conference', data);
		if (response.status === 200) {
			onSubmit();
			onClose();
		}
	}

	const editConference = async (data: Conference) => {
		const response: HttpResponse<any> = await put(`/conference/${conference?.id}`, data);
		if (response.status === 200) {
			onSubmit();
			onClose();
		}
	}

	return {
		control,
		errors,
		handleSubmit,
		onSubmitForm: conference ? editConference : addConference
	}
}